import React, { PureComponent } from 'react';
import SelectInput from './SelectInput';
import { STATE_CODES } from '../../constants/index';

const stateCodeValueObjects = STATE_CODES.map((stateCode) => ({
  key: stateCode.toUpperCase(),
  label: stateCode.toUpperCase(),
  value: stateCode.toUpperCase(),
}));

type Props = {
  s?: any;
  id?: string;
  field?: any;
  values?: any[];
  trackEvent?: string;
  showErrors?: boolean;
  errorInline?: boolean;
  defaultValue?: string;
  placeholder?: string;
  funPlaceholder?: boolean;
  submitted?: boolean;
  inputProps?: any;
  onBlur?: (...args: any[]) => any;
};

class StateCodeSelectInput extends PureComponent<Props> {
  render = () => {
    const stateCodeFieldWithDefaultEmptyStringValue = {
      ...this.props.field,
      ...(this.props.field.value === undefined && { value: '' }),
    };

    return (
      <SelectInput
        defaultValue={this.props.defaultValue}
        errorInline={this.props.errorInline}
        field={stateCodeFieldWithDefaultEmptyStringValue}
        funPlaceholder={this.props.funPlaceholder}
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'string... Remove this comment to see the full error message
        id={this.props.id}
        inputProps={this.props.inputProps}
        onBlur={this.props.onBlur}
        placeholder={this.props.placeholder}
        s={this.props.s}
        showErrors={this.props.showErrors}
        submitted={this.props.submitted}
        trackEvent={this.props.trackEvent}
        values={stateCodeValueObjects}
      />
    );
  };
}

export default StateCodeSelectInput;
